import { createContext } from 'react';

const ProfileContext = createContext({
  info: null,
  prefs: null,
});

export default ProfileContext;
